export default __webpack_public_path__ + "static/media/members-screen.41573698.png";